interface UserMessageProps {
  text: string;
}

export const UserMessage = ({ text }: UserMessageProps) => (
  <li className="max-w-[85%] self-end rounded-2xl rounded-br bg-muted px-4 py-3 text-sm text-foreground">
    <p className="whitespace-pre-wrap">{text}</p>
  </li>
);
